import { z } from 'zod';

export const businessInfoSchema = z.object({
  business_name: z.string()
    .min(2, 'Business name must be at least 2 characters')
    .max(100, 'Business name must be less than 100 characters'),
  phone: z.string()
    .regex(/^\+?[1-9]\d{1,14}$/, 'Invalid phone number format (use international format, e.g., +1234567890)'),
  email: z.string()
    .email('Invalid email address')
    .max(255, 'Email must be less than 255 characters'),
  whatsapp: z.string()
    .regex(/^\+?[1-9]\d{1,14}$/, 'Invalid WhatsApp number format')
    .optional()
    .or(z.literal('')),
  description: z.string()
    .max(500, 'Description must be under 500 characters')
    .optional()
    .or(z.literal('')),
});

export const servicesSchema = z.object({
  services: z.array(z.string())
    .min(1, 'Select at least one service')
    .max(10, 'Maximum 10 services allowed'),
});

export const scheduleSchema = z.object({
  monday: z.object({
    open: z.string().nullable(),
    close: z.string().nullable(),
    closed: z.boolean(),
  }),
  tuesday: z.object({
    open: z.string().nullable(),
    close: z.string().nullable(),
    closed: z.boolean(),
  }),
  wednesday: z.object({
    open: z.string().nullable(),
    close: z.string().nullable(),
    closed: z.boolean(),
  }),
  thursday: z.object({
    open: z.string().nullable(),
    close: z.string().nullable(),
    closed: z.boolean(),
  }),
  friday: z.object({
    open: z.string().nullable(),
    close: z.string().nullable(),
    closed: z.boolean(),
  }),
  saturday: z.object({
    open: z.string().nullable(),
    close: z.string().nullable(),
    closed: z.boolean(),
  }),
  sunday: z.object({
    open: z.string().nullable(),
    close: z.string().nullable(),
    closed: z.boolean(),
  }),
  emergency_available: z.boolean().optional(),
});

export const SERVICE_OPTIONS = {
  veterinarian_individual: [
    'General Checkup',
    'Vaccinations',
    'Surgery',
    'Dental Care',
    'Emergency Care',
    'Diagnostic Tests',
    'Prescription Refills',
    'Home Visits',
  ],
  veterinary_clinic: [
    'General Checkup',
    'Vaccinations',
    'Surgery',
    'Dental Care',
    'Emergency Care',
    'Diagnostic Tests',
    'Laboratory Services',
    'Radiology',
    'Hospitalization',
  ],
  grooming_spa: [
    'Bath & Brush',
    'Full Grooming',
    'Nail Trimming',
    'Teeth Brushing',
    'Ear Cleaning',
    'De-shedding Treatment',
    'Specialized Cuts',
  ],
  dog_walker: [
    'Dog Walking',
    'Pet Sitting',
    'Overnight Care',
    'Medication Administration',
    'Pet Transportation',
    'Exercise & Play',
  ],
  pet_store: [
    'Pet Supplies',
    'Pet Food',
    'Toys & Accessories',
    'Grooming Products',
    'Pet Adoption Services',
    'Training Equipment',
  ],
  daycare_hotel: [
    'Daycare Services',
    'Overnight Boarding',
    'Extended Stay',
    'Playtime & Socialization',
    'Feeding Services',
    'Medication Administration',
    'Webcam Access',
  ],
  school_training: [
    'Basic Obedience',
    'Advanced Training',
    'Puppy Classes',
    'Behavior Modification',
    'Agility Training',
    'Service Dog Training',
    'Private Sessions',
    'Group Classes',
  ],
};
